<div class="portfolio-name-section" [formGroup]="parentForm">
  <div class="formfields__container" fxFlex="50">
    <label for="show-portfolio-name" i18n>Show Portfolio Name On Invoice?</label>
    <mat-radio-group id="show-portfolio-name" formControlName="show_portfolio_name" color="primary">
      <mat-radio-button fxFlex="50" [value]="true" id="show_portfolio_name_yes" i18n>Yes</mat-radio-button>
      <mat-radio-button fxFlex="50" [value]="false" id="show_portfolio_name_no" i18n>No</mat-radio-button>
    </mat-radio-group>
  </div>

  <div *ngIf="show_portfolio_name" class="formfields__container" fxFlex="50">
    <mat-form-field>
      <label for="portfolio_name"><span i18n>Portfolio Name</span><span class="required">*</span></label>
      <input type="text" id="portfolio_name" matInput formControlName="portfolio_name" />
    </mat-form-field>
  </div>
</div>
